import useAuth from "../../routes/login/AuthContext";
import { RenameSubnetwork } from "../../services/NetworkApi";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";

export const useSubnetworkRename = (l2Id: number) => {
  const { getAuthToken } = useAuth();
  const { updateSubNetworkValues } = useNetworkContext();
  const { selectedNetworkId } = useSelectedNetworkContext();

  const handleRename = async (subnetworkName: string) => {
    await RenameSubnetwork(
      selectedNetworkId,
      l2Id,
      { subnetworkName },
      await getAuthToken()
    );
    return updateSubNetworkValues(selectedNetworkId, l2Id, {
      l2Name: subnetworkName,
    });
  };

  return handleRename;
};
